import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client'
import { globalAuthContext } from '@headbox-ui/auth-hook'
import * as Sentry from '@sentry/browser'
import { ConfigProvider, Spin } from 'antd'
import React, { Suspense } from 'react'
import { useCookies } from 'react-cookie'
import { render } from 'react-dom'
import { createClient, Provider } from 'urql'
import Authenticator from './Components/Authenticator'
import ErrorBoundary from './Components/ErrorBoundary'
import { GoogleScript } from './Components/GoogleScript'
import I18n from './Components/I18n'
import {
  ASSET_SERVICE,
  GQL_GATEWAY,
  BUSINESS_GATEWAY,
  HEADBOX_ROOT_SERVICE,
  JWT_COOKIE_NAME,
  LOGGING,
  REFRESH_TOKEN_COOKIE_NAME,
} from './Constants'
import { setAppSentry } from './Constants/Sentry/appSentry'
import { setHeaderSentry } from './Constants/Sentry/headerSentry'
import { CONTENT_STYLE } from './Styles'
import Router from './Views/Router'

__webpack_public_path__ = `${ASSET_SERVICE}/`

// Store a copy of the Sentry instance from the header.
setHeaderSentry(Sentry.getCurrentHub())

if (LOGGING) {
  setAppSentry()
}

const client = (): any => {
  const [cookies] = useCookies([REFRESH_TOKEN_COOKIE_NAME, JWT_COOKIE_NAME])
  return new ApolloClient({
    uri: GQL_GATEWAY,
    cache: new InMemoryCache(),
    headers: {
      'x-headbox-accesstoken': cookies[JWT_COOKIE_NAME],
    },
  })
}

globalAuthContext.set({
  refreshTokenCookie: REFRESH_TOKEN_COOKIE_NAME,
  sessionTokenCookie: JWT_COOKIE_NAME,
  rootService: HEADBOX_ROOT_SERVICE,
})

const App = (): JSX.Element => {
  const [cookies] = useCookies([REFRESH_TOKEN_COOKIE_NAME, JWT_COOKIE_NAME])

  const urqlClient = createClient({
    url: BUSINESS_GATEWAY,
    fetchOptions: () => {
      return {
        headers: { 'x-headbox-accesstoken': cookies[JWT_COOKIE_NAME] },
      }
    },
  })

  return (
    <ConfigProvider>
      <I18n>
        <GoogleScript>
          <Suspense fallback={<Spin />}>
            <ErrorBoundary>
              <ApolloProvider client={client()}>
                <Provider value={urqlClient}>
                  <Authenticator>
                    <section style={CONTENT_STYLE}>
                      <Router />
                    </section>
                  </Authenticator>
                </Provider>
              </ApolloProvider>
            </ErrorBoundary>
          </Suspense>
        </GoogleScript>
      </I18n>
    </ConfigProvider>
  )
}

render(<App />, document.querySelector('app-root'))
